var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dashboard-breadcrumbs',{attrs:{"company-id":Number(_vm.companyId)}}),(_vm.HasAccess('buildings.view'))?_c('company-buildings'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }